module.exports = __webpack_public_path__ + "img/2ezBanner3.74e84fc3.jpg";